<div class="flex flex-row justify-between pt-12">
    <div class="flex flex-row">
        @if (securityService.meSignal()?.image) {
            <img
                alt="Image selected"
                class="aspect-square object-contain w-32"
                [src]="securityService.meSignal()!.image" />
        } @else {
            <div class="w-30 h-30 flex items-center justify-center fa-5x">
                <fa-layers class="fa-2x">
                    <fa-icon
                        class="text-custom-light-blue"
                        [icon]="['fas', 'circle']" />

                    <fa-icon
                        class="text-custom-blue"
                        transform="shrink-4"
                        [icon]="['fas', 'user']" />
                </fa-layers>
            </div>
        }

        <div class="flex flex-col gap-5 pl-8">
            <span class="custom-text text-lg">{{ securityService.meSignal()!.givenName }}</span>
            <span class="custom-text text-lg">{{ securityService.meSignal()!.familyName }}</span>
            <span class="custom-text text-lg">{{ securityService.meSignal()!.organization.name }}</span>
        </div>
    </div>
    <app-button
        iconSize="sm"
        [icon]="['fas', 'pen']"
        [label]="'edit' | transloco"
        [type]="ButtonType.SECONDARY"
        (onClick)="toggleEditMode.emit()" />
</div>
<div class="grid grid-cols-2 pt-10 gap-8">
    <div class="flex flex-col">
        <span class="text-custom-dark-grey">{{ 'email' | transloco }}</span>
        <span>{{ securityService.meSignal()!.email }}</span>
    </div>
    <div class="flex flex-col">
        <span class="text-custom-dark-grey">{{ 'address' | transloco }}</span>
        <span class="truncate">{{ securityService.meSignal()!.address }}</span>
    </div>
    <div class="flex flex-col">
        <span class="text-custom-dark-grey">{{ 'lang' | transloco }}</span>
        <span>{{ selectedLang() | transloco }}</span>
    </div>
</div>
